import React, { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/site";
import ImageUpload from "../ImageUpload";
import BeforeAfter from "../BeforeAfter";

export default function HeroSettings() {
  const [value, setValue] = useState({ after_url: "", before_url: "", after_id: null, before_id: null, show_before_button: true });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/admin/settings/hero");
        setValue({ after_url: "", before_url: "", after_id: null, before_id: null, show_before_button: true, ...(r.data?.value || {}) });
      } finally { setLoading(false); }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings/hero", { value }); toast.success("Innstillinger lagret"); }
    catch (e) { toast.error("Kunne ikke lagre"); }
    finally { setSaving(false); }
  };

  const afterPreview = value.after_id ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${value.after_id}` : value.after_url;
  const beforePreview = value.before_id ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${value.before_id}` : value.before_url;

  if (loading) return <div className="p-8 text-center bg-white border rounded-xl"><Loader2 className="animate-spin inline text-[#1B3626]"/></div>;

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-display text-lg sm:text-xl font-bold">Forsidebilde (hero)</h2>
        <p className="text-sm text-[#555E68] mt-1">Rediger etter-bildet (hovedbildet) og før-bildet som vises når man trykker "Se før-bilde" på forsiden.</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-xl bg-white border border-[#E2DDD5] p-4 space-y-3">
          <div className="font-semibold text-sm">Etter-bilde (hovedbilde)</div>
          <ImageUpload label="Last opp" mode="single" scope="hero" value={value.after_id ? { id: value.after_id } : (value.after_url ? { url: value.after_url } : null)} onChange={(v) => setValue({ ...value, after_id: v?.id || null, after_url: v?.id ? "" : (v?.url || "") })} />
          <label className="block"><span className="text-[11px] uppercase tracking-wider text-[#555E68]">... eller URL</span>
            <input value={!value.after_id ? (value.after_url || "") : ""} onChange={(e) => setValue({...value, after_url: e.target.value, after_id: null})} placeholder="https://..." className="mt-1 w-full rounded-md border border-[#D5D0C7] px-3 py-2 text-xs" data-testid="hero-after-url" />
          </label>
        </div>
        <div className="rounded-xl bg-white border border-[#E2DDD5] p-4 space-y-3">
          <div className="font-semibold text-sm">Før-bilde</div>
          <ImageUpload label="Last opp" mode="single" scope="hero" value={value.before_id ? { id: value.before_id } : (value.before_url ? { url: value.before_url } : null)} onChange={(v) => setValue({ ...value, before_id: v?.id || null, before_url: v?.id ? "" : (v?.url || "") })} />
          <label className="block"><span className="text-[11px] uppercase tracking-wider text-[#555E68]">... eller URL</span>
            <input value={!value.before_id ? (value.before_url || "") : ""} onChange={(e) => setValue({...value, before_url: e.target.value, before_id: null})} placeholder="https://..." className="mt-1 w-full rounded-md border border-[#D5D0C7] px-3 py-2 text-xs" data-testid="hero-before-url" />
          </label>
        </div>
      </div>

      <label className="flex items-center gap-2">
        <input type="checkbox" checked={value.show_before_button !== false} onChange={(e) => setValue({ ...value, show_before_button: e.target.checked })} data-testid="hero-toggle-btn" />
        <span className="text-sm">Vis "Se før-bilde" knappen på forsiden</span>
      </label>

      {afterPreview && beforePreview && (
        <div>
          <div className="text-[11px] uppercase tracking-wider text-[#555E68] mb-2">Forhåndsvisning</div>
          <BeforeAfter beforeUrl={beforePreview} afterUrl={afterPreview} />
        </div>
      )}

      <div className="flex justify-end">
        <button onClick={save} disabled={saving} className="btn-primary" data-testid="hero-save">{saving ? <Loader2 size={14} className="animate-spin"/> : <Save size={14}/>} Lagre</button>
      </div>
    </div>
  );
}
